module.exports = __webpack_public_path__ + "media/src/images/logo-full-light-bg-256474a5cbcc1eb27bbc4e8229c74e5a.png";